import api from './axios';
import { ApiResponse, Order } from '../types';

export const ordersAPI = {
  createOrder: async (data: {
    shipping_address_id: string;
    payment_method: string;
    discount_code?: string;
    notes?: string;
    shipping_method_id?: string;
  }) => {
    const res = await api.post<ApiResponse<{
      order_id: string;
      order_number: string;
      total: number;
    }>>('/api/orders', data);
    return res.data;
  },

  getMyOrders: async (params?: { page?: number; limit?: number }) => {
    const res = await api.get<ApiResponse<Order[]>>('/api/orders', { params });
    return res.data;
  },

  getOrder: async (id: string) => {
    const res = await api.get<ApiResponse<{ order: Order; items: any[] }>>(`/api/orders/${id}`);
    return res.data;
  },

  updateOrderStatus: async (id: string, status: string) => {
    const res = await api.put<ApiResponse<{}>>(`/api/orders/${id}/status`, { status });
    return res.data;
  },

  updateTracking: async (id: string, tracking_number: string, carrier?: string) => {
    const res = await api.put<ApiResponse<{}>>(`/api/orders/${id}/tracking`, {
      tracking_number,
      carrier,
    });
    return res.data;
  },

  downloadInvoice: async (id: string, orderNumber: string) => {
    const res = await api.get(`/api/orders/${id}/invoice`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Invoice-${orderNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  cancelOrder: async (id: string) => {
    const res = await api.put<ApiResponse<{}>>(`/api/orders/${id}/cancel`, {});
    return res.data;
  },
};